module.exports = __webpack_public_path__ + "static/img/support-2.dcd85e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/support-2.png
// module id = Gfgm
// module chunks = 0